import { AlignTargetContainer } from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = (theme) => ({
  root: {
    margin: 'auto',
    height: '100%',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      margin: 'auto',
      height: '100%',
    },
  },
});
export const DesignerAlignTarget = withStyles(styles, { name: 'DesignerAlignTarget' })(AlignTargetContainer);
